var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2072_12313",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2072_12313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search_2",
    d: "M18.6506 20L13.9277 15.2771C13.4458 15.6627 12.8916 15.9679 12.2651 16.1928C11.6386 16.4177 10.9719 16.5301 10.2651 16.5301C8.51406 16.5301 7.03213 15.9237 5.81928 14.7108C4.60643 13.498 4 12.0161 4 10.2651C4 8.51406 4.60643 7.03213 5.81928 5.81928C7.03213 4.60643 8.51406 4 10.2651 4C12.0161 4 13.498 4.60643 14.7108 5.81928C15.9237 7.03213 16.5301 8.51406 16.5301 10.2651C16.5301 10.9719 16.4177 11.6386 16.1928 12.2651C15.9679 12.8916 15.6627 13.4458 15.2771 13.9277L20 18.6506L18.6506 20ZM10.2651 14.6024C11.4699 14.6024 12.494 14.1807 13.3373 13.3373C14.1807 12.494 14.6024 11.4699 14.6024 10.2651C14.6024 9.06024 14.1807 8.03614 13.3373 7.19277C12.494 6.3494 11.4699 5.92771 10.2651 5.92771C9.06024 5.92771 8.03614 6.3494 7.19277 7.19277C6.3494 8.03614 5.92771 9.06024 5.92771 10.2651C5.92771 11.4699 6.3494 12.494 7.19277 13.3373C8.03614 14.1807 9.06024 14.6024 10.2651 14.6024Z",
    fill: "#141414"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3313f7a7e054409bb4bd860955628a66.svg";
export { ForwardRef as ReactComponent };